import { AIVideoActions } from "../actions/aiVideo";

const INITIAL_STATE = {
    list: {
        data: [],
        totalItems: 0,
        totalPages: 1,
    },
    loading: false,
    error: null,

    // Single video details
    details: {
        data: null,
        loading: false,
        error: null,
    },

    // Settings (templates + creation settings)
    settings: {
        templates: [],
        templatesLoading: false,
        templatesError: null,

        creationSettings: null,
        creationLoading: false,
        creationError: null,
        creationSaving: false,
    },

    // Homepage summary
    homepage: {
        liveVideos: [],
        liveVideosTotal: 0,
        pastVideos: [],
        pastVideosTotal: 0,
        loading: false,
        error: null,
        loaded: false,
    },
};

function aiVideo(state = INITIAL_STATE, action) {
    switch (action.type) {
        case AIVideoActions.GET_AI_VIDEOS:
            return {
                ...state,
                list: {
                    data: action.payload?.data || [],
                    totalItems:
                        typeof action.payload?.totalItems === "number"
                            ? action.payload.totalItems
                            : 0,
                    totalPages:
                        typeof action.payload?.totalPages === "number"
                            ? action.payload.totalPages
                            : 1,
                },
            };
        case AIVideoActions.SET_AI_VIDEOS_LOADING:
            return {
                ...state,
                loading: !!action.payload,
            };
        case AIVideoActions.SET_AI_VIDEOS_ERROR:
            return {
                ...state,
                error: action.payload || null,
            };

        // Details
        case AIVideoActions.GET_AI_VIDEO_DETAILS:
            return {
                ...state,
                details: {
                    ...state.details,
                    data: action.payload || null,
                },
            };
        case AIVideoActions.SET_AI_VIDEO_DETAILS_LOADING:
            return {
                ...state,
                details: {
                    ...state.details,
                    loading: !!action.payload,
                },
            };
        case AIVideoActions.SET_AI_VIDEO_DETAILS_ERROR:
            return {
                ...state,
                details: {
                    ...state.details,
                    error: action.payload || null,
                },
            };

        // Settings
        case AIVideoActions.GET_AI_VIDEO_TEMPLATES:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    templates: action.payload || [],
                },
            };
        case AIVideoActions.SET_AI_VIDEO_TEMPLATES_LOADING:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    templatesLoading: !!action.payload,
                },
            };
        case AIVideoActions.SET_AI_VIDEO_TEMPLATES_ERROR:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    templatesError: action.payload || null,
                },
            };

        case AIVideoActions.GET_AI_VIDEO_CREATION_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    creationSettings: action.payload || null,
                },
            };
        case AIVideoActions.SET_AI_VIDEO_CREATION_SETTINGS_LOADING:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    creationLoading: !!action.payload,
                },
            };
        case AIVideoActions.SET_AI_VIDEO_CREATION_SETTINGS_ERROR:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    creationError: action.payload || null,
                },
            };
        case AIVideoActions.SET_AI_VIDEO_CREATION_SETTINGS_SAVING:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    creationSaving: !!action.payload,
                },
            };

        // Homepage summary
        case AIVideoActions.GET_AI_VIDEO_HOMEPAGE_SUMMARY:
            return {
                ...state,
                homepage: {
                    ...state.homepage,
                    liveVideos: action.payload?.liveVideos || [],
                    liveVideosTotal:
                        typeof action.payload?.liveVideosTotal === "number"
                            ? action.payload.liveVideosTotal
                            : 0,
                    pastVideos: action.payload?.pastVideos || [],
                    pastVideosTotal:
                        typeof action.payload?.pastVideosTotal === "number"
                            ? action.payload.pastVideosTotal
                            : 0,
                    loaded: true,
                },
            };
        case AIVideoActions.SET_AI_VIDEO_HOMEPAGE_LOADING:
            return {
                ...state,
                homepage: {
                    ...state.homepage,
                    loading: !!action.payload,
                },
            };
        case AIVideoActions.SET_AI_VIDEO_HOMEPAGE_ERROR:
            return {
                ...state,
                homepage: {
                    ...state.homepage,
                    error: action.payload || null,
                },
            };

        case AIVideoActions.RESET_AI_VIDEOS:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default { aiVideo };
